export enum MenuEvent {
    delete = "delete",
    copyLink = "copyLink"
}